import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { extend } from 'lodash';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { PersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.service';

@Component({
  selector: 'app-send-feedback',
  templateUrl: './send-feedback.component.html',
  styleUrls: ['./send-feedback.component.scss']
})
export class SendFeedbackComponent extends BaseComponent implements OnInit {
  feedbackText: string;
  selectedIssueValue: string;
  showThanks: boolean;
  imageCommonFolder = 'assets/common/';
  @ViewChild('divWithDir') divWithDir: HTMLElement;

  constructor(private readonly psersonalUserService:PersonalUserDataService,
    private dialogRef: MatDialogRef<SendFeedbackComponent>) { 
    super();
    this.selectedIssueValue = "";
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.divWithDir.dir = this.pageDir;
  }


  selectIssue (value: number): void{
    if (value == 1){
      this.selectedIssueValue = 'Issue';
    }
    else if (value == 2){
      this.selectedIssueValue = 'Moov';
    }
    else {
      this.selectedIssueValue = 'Other';
    }
  }

  close() {
    this.dialogRef.close();
  }

  send():void{
    if (this.selectedIssueValue == ""){
      this.selectedIssueValue = "Empty";
    }

    // console.log(`in SF selected is ${this.selectedIssueValue}`);

    this.psersonalUserService.sendFeedback(this.selectedIssueValue, this.feedbackText).subscribe(result => {
      this.showThanks = true;
      setTimeout(() => {
        this.dialogRef.close()
      }, 4000);
    });
  }

}
